/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ITrand } from './Trand';

export interface IGetMarketTrandResponse {
  /** Средняя цена квартиры на рынке **/
  averagePrice?: TGetMarketTrandResponse_AveragePrice;
  /** Средняя цена квадратного метра на рынке **/
  averageSqmPrice?: TGetMarketTrandResponse_AverageSqmPrice;
  /** Разница стоимости на начало и конец периода **/
  diffPrice?: TGetMarketTrandResponse_DiffPrice;
  /** Тренд изменения цены рост/падение/без изменения **/
  diffPriceTrand?: TGetMarketTrandResponse_DiffPriceTrand;
  /** Разница стоимости на начало и конец периода в процентах **/
  diffPercent?: TGetMarketTrandResponse_DiffPercent;
  /** Данные для вывода графика стоимости квартиры в текущем доме **/
  houseTrand?: TGetMarketTrandResponse_HouseTrand;
  /** Данные для вывода графика стоимости квартиры на рынке **/
  marketTrand?: TGetMarketTrandResponse_MarketTrand;
}

export type TGetMarketTrandResponse_AveragePrice = null | string;

export type TGetMarketTrandResponse_AverageSqmPrice = null | string;

export type TGetMarketTrandResponse_DiffPrice = null | string;

export type TGetMarketTrandResponse_DiffPriceTrand = null | EDiffPriceTrand;

export enum EDiffPriceTrand {
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
export type TGetMarketTrandResponse_DiffPercent = null | string;

export type TGetMarketTrandResponse_HouseTrand = null | TGetMarketTrandResponse_HouseTrand_1;

export type TGetMarketTrandResponse_HouseTrand_1 = ITrand[];

export type TGetMarketTrandResponse_MarketTrand = null | TGetMarketTrandResponse_MarketTrand_1;

export type TGetMarketTrandResponse_MarketTrand_1 = ITrand[];
